import { clientFetch } from '~/lib/.client/fetch';
import { ChatError } from '~/lib/errors';
import type { ProjectDeploymentInfo, GetOrCreateSiteResponse } from '~/routes/api.deploy.$project.($id)';

export async function fetchSiteInfo(projectId: string) {
  const response = await clientFetch(`/api/deploy/${projectId}`);

  const result = await response.json<ProjectDeploymentInfo>();

  return result ?? undefined;
}

export async function getOrCreateSite(
  projectId: string,
  projectTitle: string | undefined,
  hostingProvider: 'bolt' | 'netlify',
) {
  const response = await clientFetch(`/api/deploy/${projectId}`, {
    method: 'POST',
    body: JSON.stringify({ projectTitle, hostingProvider }),
  });

  const data = await response.text();

  if (!response.ok) {
    throw ChatError.parse(ChatError, data, 'An unknown error occurred when creating a site.');
  }

  return JSON.parse(data) as GetOrCreateSiteResponse;
}

export async function removeSite(projectId: string) {
  try {
    const response = await clientFetch(`/api/project/${projectId}/site`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Failed to remove the site');
    }
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : 'Failed to remove the site');
  }
}
